import React, { useState } from 'react';
import { styled } from '@mui/system';
import Text from '../../../../components/Text.js';
import Switch from '../../../../components/Switch.js';
import AdjustmentRow from './../components/AdjustmentRow.js';
import SectionLine from './../components/SectionLine.js';
import i18n from '../../../../localization/i18n.js';
import tokens from '../../../../localization/tokens.js';
const Block = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
const styles = {
  adjustmentsHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  switch: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
  }
};

/**
 *
 * @param {*} param0
 * @returns
 */
const Adjustments = ({
  invoice,
  isDivisionSummary,
  blockMemberDetails
}) => {
  /**
  * Checks if the invoice contains any adjustments with 0 as total, but is still in the adjustments object due to an added note etc.
  * 
  * @returns {boolean} Returns true if the invoice contains adjustments with non-zero total amounts, otherwise false.
  */
  const invoiceContainsNonZeroAdjustments = () => {
    for (const adjustment of invoice.adjustments) {
      if (adjustment.amounts.totals.adjustments.total !== 0) {
        return true;
      }
    }
    return false;
  };
  const [showAdjustments, toggleAdjustments] = useState(true);
  const hasNonZeroAdjustments = invoiceContainsNonZeroAdjustments();
  if (isDivisionSummary || blockMemberDetails) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(SectionLine, null), invoice.adjustments.length === 0 || !hasNonZeroAdjustments ? /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true
  }, i18n.t(tokens.labels.invoices.adjustments)) : /*#__PURE__*/React.createElement("div", {
    style: styles.adjustmentsHeader
  }, /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true
  }, i18n.t(tokens.labels.invoices.adjustments)), /*#__PURE__*/React.createElement("div", {
    style: styles.switch
  }, /*#__PURE__*/React.createElement(Text, {
    small: true,
    light: true,
    customStyle: {
      marginBottom: 3,
      marginRight: 10
    }
  }, i18n.t(tokens.labels.invoices.showDetailedAdjustments)), /*#__PURE__*/React.createElement(Switch, {
    onChange: toggleAdjustments,
    checked: showAdjustments
  }))), showAdjustments && /*#__PURE__*/React.createElement(React.Fragment, null, invoice.adjustments.length === 0 || !hasNonZeroAdjustments ? /*#__PURE__*/React.createElement(Text, {
    medium: true
  }, i18n.t(tokens.labels.invoices.noAdjustmentsSinceLastBilling)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      margin: "10px 0 20px 0"
    }
  }, i18n.t(tokens.labels.invoices.changesSinceLastInvoice)), invoice.adjustments.map((adjustment, index) => /*#__PURE__*/React.createElement(AdjustmentRow, {
    key: index,
    adjustment: adjustment
  })))));
};
export default Adjustments;